import moment from "moment";
import { IChatService } from "./IChatService";
import EventEmitter, { Events } from "./eventemitter";
import {
    ChatHubServerProxy,
    VisitorInitData,
    PreviewMessage,
    SignalRChatMessage,
    MessageModel,
    ChatMessageModel,
    ChatModel,
    AvailableUserForTransfer,
    OperatorType,
    LoginResponse,
    IDestroyRoom,
    MessageType,
    TestingChatModule,
    QAChat,
    NLUResponseModel,
    SendMessageForBotChatGeneric
} from "../models";
import { notificationService } from "./PushNotificationService";
import { chatService } from "./chatService";
import { logger } from "./Logger";
import { cacheService } from "./cacheService";
import { t } from "i18next";
import { utils } from "../utils";
import { sessionStorageService } from "./SessionStorageService";
import { fireBaseService } from "./FireBaseService";
import { cookieService } from "./CookieService";
import { DetectEnvironment } from "../EnvironmentSettings";
enum XmppChatStatus {
    Online,
    Away,
}

class SignalRChatService implements IChatService {
    userData: LoginResponse = null!;
    stateChangedString: string = "";
    InterfaceName = "";
    connect = async () => {
        if (chatService.AutoReconnect == false) {
            return;
        }

        this.userData = JSON.parse(localStorage.getItem("USER_DATA")!) as LoginResponse;

        if (this.userData == null) {
            setTimeout(this.connect, 3000);
            return;
        }

        let isDisc = this.isDisconnected();
        if (isDisc) {
            this.connectSignalR();
        }
    };

    isConnected() {
        var isConnected = $.connection.hub && $.connection.hub.state === $.signalR.connectionState.connected;

        return isConnected;
    }

    isDisconnected() {
        var isDisconnected = $.connection.hub && $.connection.hub.state === $.signalR.connectionState.disconnected;
        return isDisconnected;
    }

    getChatHub = (): SignalR.Hub.Proxy => {
        return ($.connection as any).chatHub;
    };

    getChatHubServer = (): ChatHubServerProxy => {
        return (this.getChatHub() as any).server as ChatHubServerProxy;
    };

    getUserFriendlyStateName = (state: number) => {
        switch (state) {
            case $.signalR.connectionState.connected: {
                sessionStorageService.setItem("SignalRConnectionStatus", "connected");
                EventEmitter.emit(Events.signalRConnectionStatus, "");
                return "connected";
            }
            case $.signalR.connectionState.connecting: {
                sessionStorageService.setItem("SignalRConnectionStatus", "connecting");
                EventEmitter.emit(Events.signalRConnectionStatus, "");
                return "connecting";
            }
            case $.signalR.connectionState.disconnected: {
                if (!utils.isLoggedInResourcesChatScreenActive()) {
                    sessionStorageService.setItem("SignalRConnectionStatus", "disconnected");
                    EventEmitter.emit(Events.signalRConnectionStatus, "");
                }
                return "disconnected";
            }
            case $.signalR.connectionState.reconnecting: {
                sessionStorageService.setItem("SignalRConnectionStatus", "connecting");
                EventEmitter.emit(Events.signalRConnectionStatus, "");
                return "reconnecting";
            }
            default: {
                return "unknown";
            }
        }
    };

    connectSignalR = async () => {
        try {
            this.getChatHub()?.on("initData", (initData: VisitorInitData) => {
                EventEmitter.emit(Events.onInitData, initData);
            });

            this.getChatHub()?.on("NLUResponse", (botSugestions: NLUResponseModel) => {
                EventEmitter.emit(Events.onNLUResponse, botSugestions);
            });

            this.getChatHub()?.on("initDataNew", (data) => {
                logger.log("initDataNew hit", data);
            });

            this.getChatHub()?.on("initDataNew1", (data) => {
                logger.log("initDataNew1 hit", data);
            });

            this.getChatHub()?.on("onNewNotification", (data) => {
                if (cacheService.cacheSRV(data, "notification")) {
                    EventEmitter.emit(Events.onNewNotification, data);
                    setTimeout(() => {
                        localStorage.setItem("notification", "");
                    }, 6000);
                }
            });

            this.getChatHub()?.on("InvitationAckTrn", (userInfo, chatId) => {
                EventEmitter.emit(Events.transferChatAcknowledge, { userInfo: userInfo, chatID: chatId });
                logger.log(`SignalR InvitationAckTrn : ${chatId}`);
            });

            this.getChatHub()?.on("TransferChatUnAcknowledged", (response) => {

                if (cacheService.cacheSRV(response, "transferChatACK")) {
                    EventEmitter.emit(Events.DisplayApiErrorResponse, response);
                    setTimeout(() => {
                        localStorage.setItem("transferChatACK", "");
                    }, 6000);
                }
            });

            // this.getChatHub()?.on("InvitationAck", (c, e, r) => {
            // });

            this.getChatHub()?.on("GetInvitationTrf", (data: any, usersInfo: any) => {
                var message: MessageModel = {
                    chatId: data.ChatId,
                    websiteId: data.WebsiteId,
                    visitorId: data.VisitorId,
                    visitorName: data.VisitorName,
                    VisitorJID: "",
                    autoGreetMessage: data.MessageBody,
                    userName: data.VisitorName,
                    chatType: data.ChatType,
                    userId: data.UserId,
                };

                EventEmitter.emit(Events.onNewChatReceived, message);
                this.invitationAckForTransfer(data?.VisitorId, data?.ChatId, usersInfo);
                logger.log(`SignalR GetInvitationTrf : ${data.ChatId}`);
            });

            this.getChatHub()?.on("listenQcOnChatBuzz", (c) => {
                EventEmitter.emit(Events.onReceivedBuzzChat, c);
            });

            // this.getChatHub()?.on("onBreakApply", (c) => {
            //     logger.log("OnBreakApply", c);
            // });

            // this.getChatHub()?.on("onBreakApply", (c) => {
            //     logger.log("OnBreakApply", c);
            // });

            // this.getChatHub()?.on('onChatSentNotify', (a,b) => {
            //     alert("onChatSentNotify")

            //     logger.log("onChatSentNotify", a,b);
            // });

            this.getChatHub()?.on("notifyAlert", (data) => {
                logger.log("NotifyAlert", data);
            });

            this.getChatHub()?.on("ClientAlert", (info, type) => {
                //as per zaheer we should mark client involved when we get chat id and type ==added,this listner can use in other cases also ,need to discuss with farooq
                if (type == "Added") {
                    EventEmitter.emit(Events.ClientInvolve, { chatId: info?.toString(), type: type });
                }
            });

            this.getChatHub()?.on("IspyResponse", (data, chatId) => {
                logger.log("IspyResponse", JSON.parse(data));
                const iSPY = JSON.parse(data);
                if (iSPY != "" && iSPY != null) {
                    EventEmitter.emit(Events.get_ISPY_Response, { iSpyResponse: JSON.parse(data), chatId: chatId });
                }
            });


            this.getChatHub()?.on("messageAcknowledged", (data) => {
                // EventEmitter.emit(Events.messageAcknowledged, data)
            });


            this.getChatHub()?.on("ReceiveMessage", (data) => {

                const obj = {
                    messageId: data?.MessageId,
                    chatId: data?.ChatId,
                    receiverId: this.userData?.userLoginData?.userId,
                    messageBody: data?.MessageBody,
                    status: "read"
                }

                if (data?.SenderId != this.userData?.userLoginData?.userId?.toString()) {
                    this.getChatHubServer()?.acknowledgeMessage(obj);
                }
            });
            // this.chatHub.on('botTakeOver', (data,obj,oodsf) => {
            //     alert("botTakeOver")

            //     logger.log("BotTakeOver", data);
            // });

            this.getChatHub()?.on("addMessage", (chatid, message, userType) => {
                EventEmitter.emit(Events.onPreviewMessage, { chatId: chatid, message: message, userType: userType } as PreviewMessage);
            });

            this.getChatHub()?.on("visitorData", (visitorData) => {
                var visitorDataObj = visitorData;

                if (typeof visitorData == "string") {
                    visitorDataObj = JSON.parse(visitorData);
                }
                EventEmitter.emit(Events.onVisitorDataUpdate, visitorDataObj);
            });

            this.getChatHub()?.on("GetInvitation", (data: SignalRChatMessage) => {
                var message: MessageModel = {
                    chatId: data.ChatId,
                    websiteId: data.WebsiteId,
                    visitorId: data.VisitorId,
                    visitorName: data.VisitorName,
                    VisitorJID: "",
                    autoGreetMessage: data.MessageBody,
                    userName: data.NickName,
                    chatType: data.ChatType,
                    userId: data.UserId,
                };

                

                //this.invitationAcknowledge(data.VisitorId, data.ChatId);
                EventEmitter.emit(Events.chatInviteLog, {data: JSON.stringify(data), chatId: data.ChatId});
                EventEmitter.emit(Events.onNewChatReceived, message);   

                if(data){
                    const {ChatId, WebsiteId, VisitorId, VisitorName, MessageBody  } = data
                    const logStr = `${ChatId}|${WebsiteId}|${VisitorId}|${VisitorName}|${$.connection.hub.id}|${MessageBody}|${this.userData.userLoginData.username}`
                    logger.log(`SignalR GetInvitation : ${logStr}`);
                }
            });

            this.getChatHub()?.on("DeleteMessage", (chatId: any, messageId: any) => {
                EventEmitter.emit(Events.deleteInstagramMessage, { chatId: chatId, messageId: messageId });
            });
            this.getChatHub()?.on("GetMessage", (data: SignalRChatMessage) => {
                if (
                    data.IsCustomMessage?.toLowerCase() === "[destroy room]".toLowerCase() ||
                    data.IsCustomMessage?.toLowerCase() === "[DND]".toLowerCase()
                ) {

                    EventEmitter.emit(Events.OnDestroyRoom, { chatId: data.ChatId, showMailForm: true } as IDestroyRoom);
                    if(utils.isMonitoringPanelScreenActive()){
                        EventEmitter.emit(Events.DNDClosedChat, data.ChatId);
                    }
                    EventEmitter.emit(Events.closeLoggedInChatWindow);
                    return;
                }

                if (data.IsCustomMessage?.toLowerCase() === "FirstMessage".toLowerCase()) {
                    EventEmitter.emit(Events.chatInviteLog, {data: JSON.stringify(data), chatId: data.ChatId});
                    this.setInterfaceName()
                    this.getChatHubServer()?.relogged(data.ChatId, this.InterfaceName, this.userData.userLoginData.userId);
                }

                // if (data.IsCustomMessage !== "Data") {
                //     console.error(`Unknown IsCustomMessage Found: ${data.IsCustomMessage}`);
                // }

                var msg = this.ToChatMessageModel(data);

                EventEmitter.emit(Events.onChatMessageReceived, msg);
            });

            this.getChatHub()?.on("OnCannedRefresh", () => {
                EventEmitter.emit(Events.refershCanned, "");
            });

            this.getChatHub()?.on("OnBreakApply", (value) => {
                if (utils.isOperaterScreenActive()) {
                    if (cacheService.cacheSRV(value, "alreadyAppliedBreak")) {
                        EventEmitter.emit(Events.BreakApplied, "");
                    } else {
                        EventEmitter.emit(Events.endOperatorBreak, null!);
                    }
                }
            });

            var promise = new Promise<SignalR.ConnectionStates>((resolve, reject) => {
                this.getHub().url = process.env.REACT_APP_SIGNALR_BASE_URL!;
                this.getHub().logging = process.env.REACT_APP_CONSOLE_LOGS == "true";
                this.getHub().qs = {
                    EMP_ID: this.userData.userLoginData.empCompId?.toString(),
                    USR_ID: this.userData.userLoginData.userId?.toString(),
                    USR_TYPE: this.userData?.userLoginData?.roleName,
                    Device_Name: "Web",
                };
                this.getHub()
                    .start({
                        transport: ["webSockets", "longPolling"],
                        jsonp: true,
                        xdomain: true,
                        waitForPageLoad: false,
                    } as any)
                    .done(() => {
                        logger.log(`SignalR connected with connection ID = ${$.connection.hub.id}`);
                        sessionStorageService.setItem("SignalRConnectionStatus", "connected");
                        EventEmitter.emit(Events.signalRConnectionStatus, "");
                        resolve($.connection.connectionState);
                        this.SubscribeBreakAlerts();
                    })
                    .fail(() => reject("Could not connect"));
            });

            await promise;
            this.getHub()?.stateChanged((e) => this.stateChanged(e));
            this.getHub()?.connectionSlow(() => this.connectionSlow());

            if (this.isConnected()) {
                this.RegisterMethods();

                if (utils.isOperaterScreenActive() || utils.isHybridScreenActive()) {
                    var state = document.visibilityState == "visible" ? XmppChatStatus.Online : XmppChatStatus.Away;
                    this.SaveNotificationInfo(state);
                }
            }

            this.getHub()?.disconnected(() => {
                this.clearAllListeners();
                this.onDisconnect()
            });
        } catch (error) {
            logger.log("Error", error);
            const log = `SignalR logs : [${moment().format("h:mm:ss DD/MM/YYYY")}] ----SignalR Connection failed`;
            logger.saveLog(log);
        }
    };

    setInterfaceName(chat?: ChatModel){
        if(utils.isHybridScreenActive() || utils.isMonitoringPanelScreenActive() || utils.isLoggedInResourcesScreenActive()){
            if(chat?.checkRoleQC){
                this.InterfaceName = this.userData.userLoginData.username + " (QA)"
            }else{
                this.InterfaceName = this.userData.userLoginData.username + " (QC)"
            }
        }
        
        if(utils.isOperaterScreenActive()){
            this.InterfaceName = this.userData.userLoginData.username + " (OP)"
        }
    }

    clearAllListeners() {
        const chatHub = this.getChatHub();

        chatHub?.off("initData");
        chatHub?.off("NLUResponse");
        chatHub?.off("initDataNew");
        chatHub?.off("initDataNew1");
        chatHub?.off("onNewNotification");
        chatHub?.off("InvitationAckTrn");
        chatHub?.off("TransferChatUnAcknowledged");
        chatHub?.off("GetInvitationTrf");
        chatHub?.off("listenQcOnChatBuzz");
        chatHub?.off("notifyAlert");
        chatHub?.off("ClientAlert");
        chatHub?.off("IspyResponse");
        chatHub?.off("addMessage");
        chatHub?.off("visitorData");
        chatHub?.off("GetInvitation");
        chatHub?.off("DeleteMessage");
        chatHub?.off("GetMessage");
        chatHub?.off("OnCannedRefresh");
        chatHub?.off("OnBreakApply");
    }

    RemoveNotificationInfo = () => {
        this.getChatHubServer()?.removeNotificationInfo(this.userData?.userLoginData?.userId);
    };

    relogged = (chat, customValue = "") => {
        let interfaceName = chat?.checkRoleQC ? "(QA)" : "(QC)"
        if(customValue){
            interfaceName = customValue
        }
        this.getChatHubServer()?.relogged(chat?.info?.chatId, `${this.userData?.userLoginData?.username} ${interfaceName}`, this.userData.userLoginData.userId);
    }

    SaveNotificationInfo = async (status) => {
        try {
            if (!this.isConnected()) {
                return;
            }

            var token = fireBaseService.CurrentToken;
            if (utils.isElectronBuild()) {
                token = localStorage.getItem("fireBaseToken") as any;
                if (token) {
                    token = token;
                }
            }

            if (utils.detectMobileDevice()) {
                token = cookieService.getElectronCookies("firebase_token");
            }

            if (token != "" && token != null && token != undefined && token != "undefined") {
                const obj = {
                    OS: "Web",
                    UDID: token,
                    voidUDID: "",
                    name: this.userData?.userLoginData?.username,
                    app: "WG",
                    userId: this.userData?.userLoginData?.userId,
                    status: status,
                };

                if (DetectEnvironment.config.REACT_APP_IS_FIREBASE_ENABLE) {
                    var response = await this.getChatHubServer()?.saveNotificationInfo(obj);
                }
            }
        } catch (e) { }
    };

    RegisterMethods = async () => {
        var response = await this.getChatHubServer()?.registerUser(this.userData?.userLoginData?.userId);
        logger.log(`hit registerUser method with connection ID =  ${response}`);

        let registerOperatorResponse = await this.getChatHubServer()?.registerOperator(this.userData?.userLoginData?.userId);
        logger.log(`hit registerOperator method with connection ID =  ${registerOperatorResponse}`);
    };

    disconnect = async () => {
        if (!this.isConnected()) {
            return;
        }

        this.RemoveNotificationInfo();

        this.getChatHubServer()?.unSubscribeUser();
        this.getChatHubServer()?.unRegisterWebrtcUser(this.userData.userLoginData.userId);

        $.connection?.hub?.stop();
    };

    getHub = () => {
        return $.connection.hub;
    };

    connectionSlow = () => {
        logger.log(`Slow network is detected`);
    };
    onDisconnect = async () => {
        setTimeout(() => {
            this.connect();
        }, 5000);
    };

    stateChanged = (change: SignalR.StateChanged) => {
        let _state = `SignalR state changed from ${this.getUserFriendlyStateName(change.oldState)} to ${this.getUserFriendlyStateName(
            change.newState
        )}`;
        if (this.stateChangedString != _state) {
            logger.log(_state);
        }
        this.stateChangedString = `SignalR state changed from ${this.getUserFriendlyStateName(change.oldState)} to ${this.getUserFriendlyStateName(
            change.newState
        )}`;
    };

    attachEvents = async (chatId: string, websiteId: string, visitorId: string, chat?: ChatModel) => {
        if (!this.isConnected()) {
            setTimeout(() => this.attachEvents(chatId, websiteId, visitorId), 3000);
        }

        await this.getChatHubServer()?.emit(websiteId + ":" + visitorId + ":" + chatId + ":" + this.userData.userLoginData.userId);
        this.setInterfaceName(chat)
        await this.getChatHubServer()?.relogged(chatId, this.InterfaceName, this.userData.userLoginData.userId);
        await this.getChatHubServer()?.updateGreeterStatus(chatId);
        //await this.chatHubServer.visitorData();
    };
    getUserIdOrConnId = async () => {
        if (this.isConnected()) {
            var response = await this.getChatHubServer()?.getUserIdOrConnId(this.userData.userLoginData.userId);
            if (response == "") {
                logger.log("SignalR connection id : ", response);
                this.RegisterMethods();
            }
        }
    };

    reqToGetNLUResponse = (chatModel: ChatModel, messageBody: string, industry: string) => {
        var obj: any = {
            ChatId: chatModel?.info?.chatId,
            ChatType: "BOT",
            EndTime: "false",
            MessageBody: messageBody,
            NickName: this.userData.userLoginData.username,
            TimeStamp: moment.utc().format("YYYY-MM-DD HH:mm:ss"),
            UserId: 0,
            VisitorId: chatModel?.info?.visitorId,
            VisitorName: chatModel?.info?.visitorName,
            WebsiteId: chatModel?.info?.websiteId,
            Sender: null,
            Agent: industry,
            Besttimereach: "",
            CellNo: "",
            DomainName: "deptraining.dealereprocess.com",
            Lang: "en",
        };
        this.getChatHubServer().reqToGetNLUResponse(obj);
    };

    invokeMessage = (chatid, message) => {
        this.getChatHubServer()?.invokeMessage(chatid, message, "Operator");
    };

    sendMessage = (chat: ChatModel, messageBody: string, takenOver: boolean, userId: string, messageType: MessageType, chatSize: number, TextToSpeech?: boolean) => {
        let _managerId = this.userData.userLoginData.userId.toString();
        if (messageType == MessageType.AutoQCMessage) {
            _managerId = "3551";
            userId = "-3551"
        }

        let visitorName_ = this.userData.userLoginData.username
        if (!takenOver) {
            if (utils.isQcMasterPanelActive()) {
                visitorName_ = "MasterQC"
            }
            else if (chat.operatorType === OperatorType.QualityControl) {
                visitorName_ = "QC"
            }
            else if (messageType == MessageType.AutoQCMessage) {
                visitorName_ = `QC${chatSize}`
            }
        }


        let obj: SignalRChatMessage = {
            ChatId: chat.info.chatId,
            ChatType: chat.info.chatType,
            EndTime: "false",
            IsCustomMessage: !takenOver ? (chat.operatorType === OperatorType.QualityControl ? `${messageBody}\n\r` : "Data") : messageBody,
            ManagerId: _managerId,
            MessageBody: messageBody,
            NickName: chat.pseudoName ? chat.pseudoName : visitorName_,
            SoftwareUserId: this.userData.userLoginData.userId.toString(),
            TimeStamp: moment.utc().format("YYYY-MM-DD HH:mm:ss"),
            UserId: userId.toString(),
            VisitorId: chat.info.visitorId,
            VisitorName: chat.pseudoName ? chat.pseudoName : visitorName_,
            WebsiteId: chat.info.websiteId,
            Sender: null,
            Agent: null,
            Besttimereach: "",
            CellNo: "",
            DomainName: null,
            GreetId: "",
            Lang: null,
            Miscellaneous: null,
            Subject: "",
            TransferUserId: null,
            WebsiteUrl: "",
            messageType: messageType,
            TextToSpeech: TextToSpeech ?? false,
        };

        this.getChatHubServer()?.sendMessage(obj);

        const msgObj = {
            senderId: this.userData?.userLoginData?.userId,
            chatId: chat.info.chatId,
            messageBody: messageBody
        }

        this.getChatHubServer()?.sendMessageStatus(msgObj);
    };

    sendMessageForBotChatGeneric = (chat: ChatModel, messageBody: string, takenOver: boolean, userId: string, messageType: MessageType, chatSize: number) => {
        let IsCustomMessage_ = ""
        let softwareUserId_ = ""
        let visitorName_ = ""

        if((chat.info.chatType === "AI Open Bot" || chat.info.chatType === "BOT") && (messageBody === "[LockChat]" || messageBody === "[UnLockChat]")){
            messageType = MessageType.BuzzChat
            IsCustomMessage_ = messageBody
            userId = chat.info.userId.toString() 
            softwareUserId_ = chat.info.userId.toString()
            visitorName_ = chat.info.visitorName
        }else{
            IsCustomMessage_ = "Data"
            softwareUserId_ = this.userData.userLoginData.userId.toString()
            visitorName_ = this.userData.userLoginData.username
        }

        let obj: SendMessageForBotChatGeneric = {
            ChatId: chat.info.chatId,
            MessageBody: messageBody,
            WebsiteId: chat.info.websiteId,
            VisitorId: chat.info.visitorId,
            EndTime: "false",
            WebsiteURL: "",
            VisitorName: visitorName_,
            NickName: this.userData.userLoginData.username,
            TimeStamp: moment.utc().format("YYYY-MM-DD HH:mm:ss"),
            IsCustomMessage: IsCustomMessage_,
            ManagerId: this.userData.userLoginData.userId.toString(),
            ChatType: "BOT",
            UserId: userId,
            messageType: messageType,
            SoftwareUserId: softwareUserId_,
            Sender: null,
            Agent: chat?.agent || "",  
            Besttimereach: "",
            CellNo: "",
            DomainName: null,
            GreetId: "",
            Lang: "1",
            Miscellaneous: null,
            Subject: "",
            TransferUserId: null,
            WebsiteUrl: "",
            ServerURL: chat?.serverUrl  
        };
        
        this.getChatHubServer()?.sendMessageForBotChatGeneric(obj);
    };

    SaveBotSuggestions = (values) => {
        this.getChatHubServer()?.saveBotSuggestions(values);
    };
    // sendDefaultMessage = (chat:TestingChatModule, messageBody: string) => {
    //     var _managerId = this.userData.userLoginData.userId.toString();
    //     var obj: SignalRChatMessage = {
    //         ChatId: chat.info.chatId,
    //         ChatType: chat.info.chatType,
    //         ManagerId: _managerId,
    //         MessageBody: messageBody,
    //         NickName: this.userData.userLoginData.username,
    //         // UserId: userId.toString(),
    //         VisitorId: chat.info.visitorId,
    //         VisitorName: chat.info.visitorName,
    //         WebsiteId: chat.info.websiteId,
    //     }as any;

    //     this.getChatHubServer()?.sendDefaultMessage(obj);
    // };

    async assignUsersToWebsiteQc(userId, langId) {
        await this.getChatHubServer()?.assignUsers2WebisteQc(userId, langId);
    }

    async unAssignUsersFromWebsitesQc(userId) {
        await this.getChatHubServer()?.unAssignUsersFromWebsitesTextUsQc(userId);
    }

    getId(chat: ChatModel) {
        // var user_id;
        // var userData = (JSON.parse(localStorage.getItem('hybridChats')!));
        // var user_id=userData?.filter(x=>x.chatId?.toString()===chat.localConversation[0].chatId?.toString())
        // user_id = userData.find(element => {
        //     if (element.chatId?.toString() === chat.localConversation[0].chatId?.toString()) {
        //         return element.userId
        //     }
        // });
        // return user_id?.userId;
    }

    transferChat = (chatInfo: MessageModel, targetOperator: AvailableUserForTransfer, isAutoTransfer: boolean) => {
        let usersInfo = `${this.userData.userLoginData.userId}|${this.userData.userLoginData.username}|${targetOperator?.userId}|${targetOperator?.userName}|""|""|Operator`;

        let obj: SignalRChatMessage = {
            ChatId: chatInfo.chatId,
            ChatType: chatInfo.chatType,
            EndTime: "false",
            IsCustomMessage: "Data",
            ManagerId: targetOperator.userId.toString(),
            MessageBody: "",
            NickName: this.userData.userLoginData.username,
            SoftwareUserId: this.userData.userLoginData.userId.toString(),
            TimeStamp: moment.utc().format("YYYY-MM-DD HH:mm:ss"),
            UserId: "-" + this.userData.userLoginData.userId.toString(),
            VisitorId: chatInfo.visitorId,
            VisitorName: chatInfo.visitorName,
            WebsiteId: chatInfo.websiteId,
            Sender: null,
            Agent: null,
            Besttimereach: "",
            CellNo: "",
            DomainName: null,
            GreetId: "",
            Lang: null,
            Miscellaneous: chatInfo.visitorName,
            Subject: "",
            TransferUserId: usersInfo,
            WebsiteUrl: "",
            messageType: MessageType.TransferChat,
        };

        this.getChatHubServer()?.transferChat(obj);
    };

    transferChatMessage = (chatInfo: MessageModel, fromUserName, toUserName, targetUserId, isAutoTransfer: boolean) => {
        let tMessage = `[TRANSFERCHAT]_Transferred By ${fromUserName} to ${toUserName}`;
        if (isAutoTransfer) tMessage = `[AutoTransfer]_Transferred By ${fromUserName} to ${toUserName}`;

        var transferMesg: SignalRChatMessage = {
            ChatId: chatInfo.chatId,
            ChatType: chatInfo.chatType,
            EndTime: "false",
            IsCustomMessage: "[TransferChat]",
            ManagerId: targetUserId.toString(),
            MessageBody: tMessage,
            NickName: this.userData.userLoginData.username,
            SoftwareUserId: this.userData.userLoginData.userId.toString(),
            TimeStamp: moment.utc().format("YYYY-MM-DD HH:mm:ss"),
            UserId: "-" + targetUserId.toString(),
            VisitorId: chatInfo.visitorId,
            VisitorName: this.userData.userLoginData.username.toString(),
            WebsiteId: chatInfo.websiteId,
            Sender: null,
            Agent: null,
            Besttimereach: "",
            CellNo: "",
            DomainName: null,
            GreetId: "",
            Lang: null,
            Miscellaneous: this.userData.userLoginData.username.toString(),
            Subject: "",
            TransferUserId: this.userData.userLoginData.userId.toString(),
            WebsiteUrl: "",
            messageType: MessageType.TransferChat,
        };
        this.getChatHubServer()?.sendMessage(transferMesg);
    };

    transferChatByQc = async (
        chatInfo: MessageModel,
        targetOperator: AvailableUserForTransfer,
        isAutoTransfer: boolean,
        chatType: string,
        domainName: string
    ) => {
        let usersInfo = `${chatInfo?.userId}|${chatInfo?.userName}|${targetOperator?.userId}|${targetOperator?.userName}|${this.userData.userLoginData.userId}|${this.userData.userLoginData.username}|LoggedInRes`;

        let obj: SignalRChatMessage = {
            Agent: null,
            Besttimereach: "",
            CellNo: "",
            ChatId: chatInfo.chatId,
            ChatType: chatInfo.chatType,
            EndTime: "false",
            IsCustomMessage: "[TransferChat]",
            Lang: null,
            ManagerId: targetOperator.userId.toString(),
            MessageBody: "",
            Miscellaneous: chatInfo.visitorName,
            NickName: "Greeter",
            Sender: null,
            SoftwareUserId: "",
            Subject: "",
            TimeStamp: moment.utc().format("YYYY-MM-DD HH:mm:ss"),
            TransferUserId: usersInfo,
            UserId: targetOperator.userId.toString(),
            VisitorId: chatInfo.visitorId,
            VisitorName: chatInfo.visitorName,
            WebsiteId: chatInfo.websiteId,
            DomainName: domainName,
            GreetId: "",
            WebsiteUrl: "",
            messageType: MessageType.TransferChat,
        };

        this.getChatHubServer()?.transferChat(obj);
    };

    reAttachExistingRoom = async (item: ChatModel) => {
        var messages: SignalRChatMessage[] = await this.getChatHubServer()?.getAllData(item.info.chatId);

        if (item.localConversation.length < 1) {
            messages.map((m) => this.ToChatMessageModel(m)).forEach((msg) => EventEmitter.emit(Events.onChatMessageReceived, msg));
        }
    };

    leaveRoom = (chatId: string) => {
        this.getChatHubServer()?.leaveRoom(chatId);
    };

    AddInvolveChatState = (chatId: string) => {
        let response = this.getChatHubServer()?.addInvolveChatState(this?.userData?.userLoginData?.username, chatId);
        return response;
    };

    removeNotificationInfo = () => {
        if (!this.isConnected()) {
            return;
        }

        this.getChatHubServer()?.removeNotificationInfo(this?.userData?.userLoginData?.userId);
    };

    dndChat = (chatType: string, roomId: string, websiteId: string, visitorId: string, chatId: string): void => {
        let obj: SignalRChatMessage = {
            IsCustomMessage: "[DND]",
            EndTime: "true",
            UserId: this.userData.userLoginData.userId.toString(),
            ManagerId: this.userData.userLoginData.userId.toString(),
            ChatType: chatType,
            ChatId: roomId,
            WebsiteId: websiteId,
            NickName: this.userData.userLoginData.username,
            MessageBody: "[DND]",
            VisitorName: this.userData.userLoginData.username,
            TimeStamp: moment.utc().format("YYYY-MM-DD HH:mm:ss"),
            VisitorId: visitorId,
            SoftwareUserId: this.userData.userLoginData.userId.toString(),
            Sender: null,
            Agent: null,
            Besttimereach: "",
            CellNo: "",
            DomainName: null,
            GreetId: "",
            Lang: null,
            Miscellaneous: null,
            Subject: "",
            TransferUserId: null,
            WebsiteUrl: "",
            messageType: MessageType.TransferChat,
        };
        this.getChatHubServer()?.sendMessage(obj);
    };

    blockChat(chatType: string, roomId: string, websiteId: string, visitorId: string, chat_id: string): void {
        let obj: SignalRChatMessage = {
            IsCustomMessage: "[Ignore]",
            EndTime: "true",
            UserId: this.userData.userLoginData.userId.toString(),
            ManagerId: this.userData.userLoginData.userId.toString(),
            ChatType: chatType,
            ChatId: roomId,
            WebsiteId: websiteId,
            NickName: this.userData.userLoginData.username,
            MessageBody: "[Ignore]",
            VisitorName: this.userData.userLoginData.username,
            TimeStamp: moment.utc().format("YYYY-MM-DD HH:mm:ss"),
            VisitorId: visitorId,
            SoftwareUserId: "-" + this.userData.userLoginData.userId.toString(),
            Sender: null,
            Agent: null,
            Besttimereach: "",
            CellNo: "",
            DomainName: null,
            GreetId: "",
            Lang: "1",
            Miscellaneous: null,
            Subject: "",
            TransferUserId: null,
            WebsiteUrl: "",
            messageType: MessageType.Dnd,
        };
        this.getChatHubServer()?.sendMessage(obj);
    }

    QCMessageByCannedKeyword = async (
        message: string,
        chatType: string,
        roomId: string,
        websiteId: string,
        visitorId: string,
        chat_id: string,
        VisitorName: string
    ) => {
        let obj: SignalRChatMessage = {
            IsCustomMessage: "",
            EndTime: "false",
            UserId: "-" + this.userData.userLoginData.userId.toString(),
            ManagerId: this.userData.userLoginData.userId.toString(),
            ChatType: chatType,
            ChatId: chat_id,
            WebsiteId: websiteId,
            NickName: VisitorName,
            MessageBody: message,
            VisitorName: VisitorName,
            TimeStamp: moment.utc().format("YYYY-MM-DD HH:mm:ss"),
            VisitorId: visitorId,
            SoftwareUserId: "-" + this.userData.userLoginData.userId.toString(),
            Sender: null,
            Agent: null,
            Besttimereach: "",
            CellNo: "",
            DomainName: null,
            GreetId: "",
            Lang: "1",
            Miscellaneous: null,
            Subject: "",
            TransferUserId: null,
            WebsiteUrl: "",
            messageType: MessageType.QCGreeting,
        };
        this.getChatHubServer()?.sendMessage(obj);
    };

    updateNickName = (chatType: string, chatId: string, websiteId: Number, visitorId: string, visitorName: string) => {
        let obj: SignalRChatMessage = {
            ChatType: chatType,
            EndTime: "false",
            ChatId: chatId,
            IsCustomMessage: "[NICKCHANGE]",
            MessageBody: "[NICKCHANGE]",
            UserId: this.userData.userLoginData.userId.toString(),
            ManagerId: this.userData.userLoginData.userId.toString(),
            TimeStamp: moment.utc().format("YYYY-MM-DD HH:mm:ss"),
            WebsiteId: websiteId.toString(),
            VisitorName: visitorName,
            NickName: visitorName,
            VisitorId: visitorId,
            SoftwareUserId: this.userData.userLoginData.userId.toString(),
            Sender: null,
            Agent: null,
            Besttimereach: "",
            CellNo: "",
            DomainName: null,
            GreetId: "",
            Lang: null,
            Miscellaneous: null,
            Subject: "",
            TransferUserId: null,
            WebsiteUrl: "",
            messageType: MessageType.Dnd,
        };

        this.getChatHubServer()?.sendMessage(obj);
    };

    private ToChatMessageModel(data: SignalRChatMessage): ChatMessageModel {
        return new ChatMessageModel(
            data.ChatId,
            data.UserId,
            data.VisitorName,
            data.MessageBody,
            data.TimeStamp,
            data.ChatId, // TODO. Fix this,
            data.ChatType,
            data.ManagerId,
            data.NickName,
            data.messageType,
            data.WebsiteId,
            data.Subject, // this subject field is using for messageID and we are deleting the instagram message by this field.
            data.Agent,
            data.ServerURL
        );
    }

    buzzQC = (buzzType: string, chat: ChatModel, messageBody: string) => {
        let obj: SignalRChatMessage = {
            ChatId: chat.info.chatId,
            MessageBody: messageBody,
            WebsiteId: chat.info.websiteId,
            VisitorId: chat.info.visitorId,
            EndTime: "false",
            VisitorName: chat.info.visitorName,
            NickName: this.userData.userLoginData.username,
            TimeStamp: moment.utc().format("YYYY-MM-DD HH:mm:ss"),
            IsCustomMessage: "[BUZZCHAT]",
            ManagerId: this.userData.userLoginData.userId.toString(),
            ChatType: chat.info.chatType,
            UserId: "-" + this.userData.userLoginData.userId.toString(),
            messageType: MessageType.BuzzChat,
            SoftwareUserId: "-" + this.userData.userLoginData.userId.toString(),
            Sender: null,
            Agent: null,
            Besttimereach: "",
            CellNo: "",
            DomainName: null,
            GreetId: "",
            Lang: "1",
            Miscellaneous: null,
            Subject: "",
            TransferUserId: null,
            WebsiteUrl: "",
        };
        this.getChatHubServer()?.sendMessage(obj);
    };

    sendNotification = (chatId: string, websiteId: string, type: string) => {
        let obj = {
            chatId: chatId,
            websiteId: websiteId,
            type: type,
        };
        this.getChatHubServer()?.sendBuzz(obj);
    };

    routChatToOperatorQC = (chat: ChatModel, langId: number, chatStartTime: string) => {
        // let obj = {
        //     param: "Buzz",
        //     chatId: chat.info.chatId,
        //     chatStartTime: chatStartTime,
        //     chatType: chat.info.chatType,
        // };
        this.getChatHubServer()?.routChatToOperatorQc(chat.info.websiteId, langId, "buzz", chat.info.chatId, chatStartTime, "");
    };

    invitationAcknowledge = async (visitorId: any, chatId: any) => {
        if (!this.isConnected()) {
            setTimeout(() => {
                this.invitationAcknowledge(visitorId, chatId)
            }, 3000);
        }

        
        this.getChatHubServer()?.invitationAck(visitorId, chatId);
        logger.log(`SignalR invitationAcknowledge : ${chatId}`);

    };

    invitationAckForTransfer = (visitorId: any, chatId: any, userId: any) => {
        this.getChatHubServer()?.invitationAckForTransfer(visitorId, chatId?.toString(), userId);
        logger.log(`SignalR invitationAckForTransfer : ${chatId}`);
    };
    SendFakeVisitorInfo = (visitorId: any, referer: any, websiteId: any) => {
        this.getChatHubServer()?.saveFakeVisitorInfo(visitorId, referer, websiteId?.toString());
    };
    BroadCastBreakNotification = (msg: string) => {
        try {
            if (this.userData.interfaces?.some((x) => x.interfaceName == "Break Requests")) {
                let res = this.getChatHubServer()?.broadcastBreakNotification(msg);
                return res;
            }
        } catch (e) { }
    };

    SubscribeBreakAlerts = () => {
        if (this.userData.interfaces?.some((x) => x.interfaceName == "Break Requests")) {
            let res = this.getChatHubServer()?.subscribeBreakAlerts();
            return res;
        }
    };

    isChatTransferredFrom = (data: SignalRChatMessage) => {
        return (
            data.IsCustomMessage?.toLowerCase() === "[TransferChat]".toLowerCase() &&
            data.TransferUserId === this.userData.userLoginData.userId.toString()
        );
    };

    sendGreeterMsgAsQC = (msg: string, chatId: string, websiteId: Number, visitorName: string, chat?: ChatModel) => {
        if (chat) {
            var obj: SignalRChatMessage = {
                ChatId: chat.info.chatId,
                ChatType: chat.info.chatType,
                EndTime: "false",
                IsCustomMessage: msg,
                ManagerId: this.userData.userLoginData.userId.toString(),
                MessageBody: msg,
                NickName: this.userData.userLoginData.username,
                SoftwareUserId: this.userData.userLoginData.userId.toString(),
                TimeStamp: moment.utc().format("YYYY-MM-DD HH:mm:ss"),
                UserId: "-" + this.userData.userLoginData.userId.toString(),
                VisitorId: chat.info.visitorId,
                VisitorName: chat.info.visitorName,
                WebsiteId: chat.info.websiteId,
                Sender: null,
                Agent: null,
                Besttimereach: "",
                CellNo: "",
                DomainName: null,
                GreetId: "",
                Lang: null,
                Miscellaneous: null,
                Subject: "",
                TransferUserId: null,
                WebsiteUrl: "",
                messageType: MessageType.QCGreeting,
            };
            this.getChatHubServer()?.sendMessage(obj);
        }
    };

    sendInitVideoMsg = (msg: string, chat?: ChatModel) => {
        if (chat) {
            var obj: SignalRChatMessage = {
                ChatId: chat.info.chatId,
                ChatType: chat.info.chatType,
                EndTime: "false",
                IsCustomMessage: msg,
                ManagerId: this.userData.userLoginData.userId.toString(),
                MessageBody: msg,
                NickName: this.userData.userLoginData.username,
                SoftwareUserId: this.userData.userLoginData.userId.toString(),
                TimeStamp: moment.utc().format("YYYY-MM-DD HH:mm:ss"),
                UserId: "-" + this.userData.userLoginData.userId.toString(),
                VisitorId: chat.info.visitorId,
                VisitorName: chat.info.visitorName,
                WebsiteId: chat.info.websiteId,
                Sender: null,
                Agent: null,
                Besttimereach: "",
                CellNo: "",
                DomainName: null,
                GreetId: "",
                Lang: null,
                Miscellaneous: null,
                Subject: "",
                TransferUserId: null,
                WebsiteUrl: "",
                messageType: MessageType.QCGreeting,
            };
            this.getChatHubServer()?.sendMessage(obj);
        }
    };

    UpdateGreetersCanned = async () => {
        if (this.isConnected()) {
            await this.getChatHubServer()?.updateGreetersCanned();
            notificationService.showNotification("", t("notificationMessages.sent"));
        } else {
            setTimeout(() => {
                this.UpdateGreetersCanned();
            }, 2000);
            // notificationService.showNotification("", t('notificationMessages.Unable-update'));
        }
    };

    reAssignedChats = async (chatIds: string, visitorIds: string, websiteIds: string, userIds: string) => {
        return await this.getChatHubServer()?.reAssignedChats(chatIds, visitorIds, websiteIds, userIds);
    };
    ApplyGreeterBreak = async (userId: number) => {
        return await this.getChatHubServer()?.sendBreakAlert(userId);
    };
}

function onAppVisibilityChange() {
    if (document.visibilityState == "visible") {
        EventEmitter.emit(Events.resetSignalRConnectionChecker, "");
    }

    if (utils.isOperaterScreenActive() || utils.isHybridScreenActive()) {
        var state = document.visibilityState == "visible" ? XmppChatStatus.Online : XmppChatStatus.Away;
        signalRChatService?.SaveNotificationInfo(state);
    }
}
document.addEventListener("visibilitychange", onAppVisibilityChange);

var signalRChatService = new SignalRChatService();
export { signalRChatService };
